export const EnumToArray = (enumObject: any) =>{
    const all = [];
    for(const key in enumObject) {
       all.push({label: enumObject[key], value: enumObject[key]});
    }
    return all;
}